module.exports = __webpack_public_path__ + "static/media/Ramones_main_t.c115292c.jpg";